 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/text/cover'
 import TEXT978398973539251255 from '@/components/text/9783989735392-51255'
 import TEXT978398973539249754 from '@/components/text/9783989735392-49754'
 import TEXT978398973539232427 from '@/components/text/9783989735392-32427'
 import TEXT978398973539230189 from '@/components/text/9783989735392-30189'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/cover",
 			"name" : "text/cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/text/9783989735392-51255",
 			"name" : "text/9783989735392-51255",
 			"component" : TEXT978398973539251255
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js